import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconVolumeOffComponent } from "./med-icon-volume-off.component";

@NgModule({
  declarations: [
    MedIconVolumeOffComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconVolumeOffComponent,
  ],
})
export class MedIconVolumeOffModule { }
